import { render, staticRenderFns } from "./BookingGroupPage.vue?vue&type=template&id=6214b05e"
import script from "./BookingGroupPage.vue?vue&type=script&lang=js"
export * from "./BookingGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports